export const success = {
  Success: 'Éxito',
  'Your contract was successfully reparceled!':
    'Su contrato ha sido refinanciado con éxito!',
};
